import React, { useState, useEffect } from "react";
import { jwtDecode } from "jwt-decode";

const Summary = () => {
  const [userName, setUserName] = useState("User");

  useEffect(() => {
    
    const token = localStorage.getItem("token");

    if (token) {
      try {
        
        const decoded = jwtDecode(token);

        let nameToDisplay = decoded.name || decoded.email || "User";

        if (nameToDisplay.includes("@")) {
          nameToDisplay = nameToDisplay.split("@")[0];
        }

        
        const formattedName = nameToDisplay.charAt(0).toUpperCase() + nameToDisplay.slice(1);
        
        setUserName(formattedName);
      } catch (err) {
        console.error("Error decoding token in Summary component:", err);
      }
    }
  }, []);

  return (
    <>
      <div className="username">
        <h6>Hi, {userName}!</h6>
        <hr className="divider" />
      </div>

      <div className="section">
        <span>
          <p>Equity</p>
        </span>

        <div className="data">
          <div className="first">
            <h3>3.74k</h3>
            <p>Margin available</p>
          </div>
          <hr />

          <div className="second">
            <p>
              Margins used <span>0</span>{" "}
            </p>
            <p>
              Opening balance <span>3.74k</span>{" "}
            </p>
          </div>
        </div>
        <hr className="divider" />
      </div>

      <div className="section">
        <span>
          <p>Holdings (13)</p>
        </span>

        <div className="data">
          <div className="first">
            <h3 className="profit">
              1.55k <small>+5.20%</small>{" "}
            </h3>
            <p>P&L</p>
          </div>
          <hr />

          <div className="second">
            <p>
              Current Value <span>31.43k</span>{" "}
            </p>
            <p>
              Investment <span>29.88k</span>{" "}
            </p>
          </div>
        </div>
        <hr className="divider" />
      </div>
    </>
  );
};

export default Summary;